export const barrierTypes = [
    {
        name: 'Dam',
        slug: 'dam',
        desc: 'A dam constrains the flow of water and raises the water level, forming a reservoir'
    },
    {
        name: 'Weir',
        slug: 'weir',
        desc: 'A weir is aimed at regulating flow conditions, intercepting sediment, or reducing the channel slope. ' +
            'Water often flows freely over the top.'
    },
    {
        name: 'Culvert',
        slug: 'culvert',
        desc: 'A culvert allows a stream or river to flow through/under an obstruction. ' +
            'Culverts vary from round and elliptical to box-shaped.'
    },
    {
        name: 'Ford',
        slug: 'ford',
        desc: 'A ford is a structure in a river or stream which creates a shallow place for crossing by vehicle or on foot.'
    },
    {
        name: 'Sluice',
        slug: 'sluice_gate',
        desc: 'A sluice is a movable barrier aimed at controlling water levels and flow rates. ' +
            'Sluices come in many shapes and sizes.'
    },
    {
        name: 'Ramp',
        slug: 'ramp',
        desc: 'A ramp or a bed sill is aimed at stabilizing the channel bed and reducing erosion. ' +
            'They often have a height of less than 1-2 meters.'
    },
    {
        name: 'Other',
        slug: 'other',
        desc: 'An unknown barrier type'
    }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/types.ts